import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Module-level cache so we don't refetch on every page mount
let cachedHeaders = null;
let inflight = null;

const fetchAll = () => {
  if (cachedHeaders) return Promise.resolve(cachedHeaders);
  if (inflight) return inflight;
  inflight = axios.get(`${API_URL}/page-headers`)
    .then((res) => { cachedHeaders = res.data || {}; inflight = null; return cachedHeaders; })
    .catch(() => { inflight = null; cachedHeaders = {}; return cachedHeaders; });
  return inflight;
};

export const usePageHeader = (slug, defaults = {}) => {
  const [header, setHeader] = useState({
    heading: defaults.heading || '',
    subheading: defaults.subheading || '',
    image_url: defaults.image_url || '',
  });

  useEffect(() => {
    let mounted = true;
    fetchAll().then((all) => {
      if (!mounted) return;
      const stored = all[slug];
      if (stored) {
        setHeader({
          heading: stored.heading || defaults.heading || '',
          subheading: stored.subheading || defaults.subheading || '',
          image_url: stored.image_url || defaults.image_url || '',
        });
      }
    });
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  return header;
};

// Allow invalidation after admin saves so other tabs/pages pick up changes
export const invalidatePageHeadersCache = () => { cachedHeaders = null; };
